// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://evheflzvayrquurnvybm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV2aGVmbHp2YXlycXV1cm52eWJtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc2OTc0NDEsImV4cCI6MjA5MzI3MzQ0MX0.LcuuSdUF_vfs6vhDVpZJXGPu3KtE_AjAI5eKTgaiAns";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});